// This file was auto-generated by __GENERATE_CHAIN_PRESETS__.js. Do not edit manually.

import { yooldoVerseTestnet as _yooldoVerseTestnet } from 'viem/chains'
import { createCommon } from '../createCommon.js'

/**
 * Creates a common configuration for the yooldoVerseTestnet chain.
 * @type {import('../Common.js').Common}
 * @description
 * Chain ID: 50006
 * Chain Name: Yooldo Verse Testnet
 * Default Block Explorer: https://explorer.testnet.yooldo-verse.xyz
 * Default RPC URL: https://rpc.testnet.yooldo-verse.xyz
 * @example
 * import { createMemoryClient } from 'tevm'
 * import { yooldoVerseTestnet } from 'tevm/common'
 * import { http } from 'tevm'
 *
 * const client = createMemoryClient({
 *   common: yooldoVerseTestnet,
 *   fork: {
 *     transport: http({ url: 'https://example.com' })({})
 *   },
 * })
 */
export const yooldoVerseTestnet = createCommon({
	..._yooldoVerseTestnet,
	loggingLevel: 'warn',
	eips: [],
	hardfork: 'prague',
})
